import { DOMAIN_OVERVIEW_SUGGESTIONS } from './domainOverview';
import { CLUSTER_INFO_SUGGESTIONS } from './clusterInfo';
import { EC2_INSTANCE_SUGGESTIONS } from './ec2Instances';
import { CLUSTER_INSIGHTS_SUGGESTIONS } from './clusterInsights';
import { DASHBOARD_METRICS_SUGGESTIONS } from './dashboardMetrics';

export {
  DOMAIN_OVERVIEW_SUGGESTIONS,
  CLUSTER_INFO_SUGGESTIONS,
  CLUSTER_INSIGHTS_SUGGESTIONS,
};

export const ALL_SUGGESTIONS = [
  ...DOMAIN_OVERVIEW_SUGGESTIONS,
  ...CLUSTER_INFO_SUGGESTIONS,
  ...EC2_INSTANCE_SUGGESTIONS,
  ...CLUSTER_INSIGHTS_SUGGESTIONS,
  ...DASHBOARD_METRICS_SUGGESTIONS,
];
